/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Premium_VoicesInputs */

const en_settings_premium_voices = /** @type {(inputs: Settings_Premium_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium voices`)
};

const es_settings_premium_voices = /** @type {(inputs: Settings_Premium_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces premium`)
};

/**
* | output |
* | --- |
* | "Premium voices" |
*
* @param {Settings_Premium_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_premium_voices = /** @type {((inputs?: Settings_Premium_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Premium_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_premium_voices(inputs)
	return en_settings_premium_voices(inputs)
});